import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { AnimalIllnesses } from '@ps20/bff-models';

export const URL_ANIMAL_ILLNESSES = '/privatschutz/api/animalIllnesses';

export enum AnimalIllnessesRequestedActions {
  ANIMAL_ILLNESSES_REQUEST_SUCCESSFUL = 'ANIMAL_ILLNESSES_REQUEST_SUCCESSFUL',
  ANIMAL_ILLNESSES_REQUEST_FAILED = 'ANIMAL_ILLNESSES_REQUEST_FAILED',
}

export function* watchAnimalIllnessesRequested(): SagaIterator {
  yield takeEvery(GlobalActions.PRODUKT_REQUESTED, safeSaga(getAnimalIllnessesSaga, App.SHOP));
  yield takeEvery(
    AnimalIllnessesRequestedActions.ANIMAL_ILLNESSES_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP),
  );
}

export function* getAnimalIllnessesSaga(action: GlobalAction<ProduktRequested>): SagaIterator {
  if (action.payload.appId !== App.TKV_V2 || action.payload.catalogsProvided) {
    return yield cancel();
  }
  if (action.payload.catalogsForGroup) {
    // asked for the whole Tiergruppe: only the store of the asking offer answers
    const state: { angebotsId?: string } = yield select();
    if (action.payload.angebotsId !== state.angebotsId) {
      return yield cancel();
    }
  }
  const globalPut = GlobalPut.getInstance();
  return yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_ANIMAL_ILLNESSES,
      successEvent: AnimalIllnessesRequestedActions.ANIMAL_ILLNESSES_REQUEST_SUCCESSFUL,
      errorEvent: AnimalIllnessesRequestedActions.ANIMAL_ILLNESSES_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction): SagaIterator {
  const animalIllnesses: AnimalIllnesses = successAction.payload;
  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().animalIllnessesRecieved(animalIllnesses),
  );
}
